import { render, staticRenderFns } from "./pingshen.vue?vue&type=template&id=fe46b586"
import script from "./pingshen.vue?vue&type=script&lang=js"
export * from "./pingshen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports